var _circle, _circle2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccessNeeded(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 34,
    r: 33.75,
    fill: "#E39908",
    fillOpacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 34,
    r: 25,
    fill: "#E39908"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.7734 27.6025L25.7384 38.6068C25.7304 38.6215 25.722 38.6359 25.7133 38.6501C25.4197 39.1271 25.3561 39.491 25.4272 39.7356C25.7451 40.8307 26.7566 41.6295 27.9521 41.6295H40.0479C41.2434 41.6295 42.2549 40.8307 42.5728 39.7356C42.6439 39.491 42.5803 39.1271 42.2867 38.6501C42.278 38.6359 42.2696 38.6215 42.2616 38.6068L36.2266 27.6025C35.1973 25.9606 32.8027 25.9606 31.7734 27.6025ZM30.0579 26.5739C31.8653 23.6368 36.1347 23.6368 37.9421 26.5739C37.9509 26.5881 37.9593 26.6026 37.9673 26.6172L44.0038 37.6244C44.4092 38.2906 44.7936 39.2599 44.4935 40.2934C43.9341 42.2198 42.1569 43.6295 40.0479 43.6295H27.9521C25.8431 43.6295 24.0659 42.2198 23.5065 40.2934C23.2064 39.2599 23.5908 38.2906 23.9962 37.6244L30.0327 26.6172C30.0408 26.6026 30.0491 26.5881 30.0579 26.5739ZM34 29.1328C34.5523 29.1328 35 29.5805 35 30.1328V34.9711C35 35.5234 34.5523 35.9711 34 35.9711C33.4477 35.9711 33 35.5234 33 34.9711V30.1328C33 29.5805 33.4477 29.1328 34 29.1328ZM34 37.5573C34.5523 37.5573 35 38.005 35 38.5573V38.5998C35 39.1521 34.5523 39.5998 34 39.5998C33.4477 39.5998 33 39.1521 33 38.5998V38.5573C33 38.005 33.4477 37.5573 34 37.5573Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessNeeded);
export default __webpack_public_path__ + "static/media/access_needed.551828b8e6579eb85ad70d29f04cf189.svg";
export { ForwardRef as ReactComponent };